<template>
  <v-card
    v-if="
      selectedList == 1 || ($vuetify.breakpoint.mdAndDown && selectedList == 0)
    "
    class="my-2 grid-view dialog-cls card-border"
    :height="$vuetify.breakpoint.mdAndUp ? 'unset' : 'auto'"
    outlined
  >
    <v-col cols="12" class="px-3 py-2">
      <span class="fixed-length">
        <router-link
          class="text-link-with-icon"
          :to="{ path: '/products/view/' + product._id }"
        >
          <span class="dialog-title mx-3 link-active">{{ product.name }}®</span>
        </router-link>
      </span>
      <v-card-subtitle class="dialog-text fixed-length mx-3 pa-0">{{
        product.formulation
      }}</v-card-subtitle>
      <div class="dialog-title-md mx-3 pb-3">
        <!-- <span v-if="retailPrice.length > 0"
          >£{{ Math.min(...retailPrice) }}</span
        >
         <span v-if="retailPrice.length > 1"
          >&nbsp;-&nbsp;£{{ Math.max(...retailPrice) }}</span
        > -->
        <span
          class="dialog-small-text in-stock-cls font-weight-bold d-inline float-right"
          v-if="product.stockStatus === 'In Stock'"
          >In Stock</span
        >
        <span
          class="dialog-small-text in-stock-cls font-weight-bold text--disabled d-inline float-right"
          v-if="product.stockStatus === 'Out of Stock'"
          >Out of Stock</span
        >
        <span
          class="dialog-small-text in-stock-cls font-weight-bold d-inline float-right"
          v-if="product.stockStatus === 'Coming Soon'"
          >Coming Soon</span
        >
        <span
          class="dialog-small-text in-stock-cls font-weight-bold d-inline float-right"
          v-if="product.stockStatus === 'Available in 1 week'"
          >Available in 1 week</span
        >
        <span
          class="dialog-small-text in-stock-cls font-weight-bold d-inline float-right"
          v-if="product.stockStatus === 'Available in 2 weeks'"
          >Available in 2 weeks</span
        >
        <span
          class="dialog-small-text in-stock-cls font-weight-bold d-inline float-right"
          v-if="product.stockStatus === 'Available in 3 weeks'"
          >Available in 3 weeks</span
        >
        <span
          class="dialog-small-text in-stock-cls font-weight-bold d-inline float-right"
          v-if="product.stockStatus === 'Available in 4 weeks'"
          >Available in 4 weeks</span
        >
        <span
          class="dialog-small-text in-stock-cls font-weight-bold d-inline float-right"
          v-if="product.stockStatus === 'Low Stock'"
          >Low Stock</span
        >
      </div>
    </v-col>
    <v-divider></v-divider>
    <v-card-text
      class="card-box pa-5"
      :class="$vuetify.breakpoint.mdAndUp ? 'd-flex' : ''"
    >
      <div :class="$vuetify.breakpoint.mdAndUp ? 'img-container' : ''">
        <router-link
          class="text-link-with-icon"
          :to="{ path: '/products/view/' + product._id }"
        >
          <i class="image-box">
            <img
              class="image-box"
              :src="productImage[0].url"
              v-if="productImage.length > 0"
            />
            <img
              class="image-box"
              src="https://growbiotech-prod.s3.eu-west-2.amazonaws.com/1606301620817.png"
              v-else
            />
          </i>
          <v-chip
            color="#fcae00"
            class="white--text video-chip-grid-view"
            label
            v-if="product.videoUrl"
            >VIDEO</v-chip
          >
        </router-link>
      </div>
      <div :style="$vuetify.breakpoint.mdAndUp ? 'width:50%' : ''">
        <v-col cols="12" class="px-8">
          <div class="dialog-title-md mt-1">Manufacturer</div>
          <div v-if="product.manufacturersObj" class="dialog-text pl-3 pt-2">
            - {{ product.manufacturersObj.name }}
          </div>
          <div class="dialog-title-md mt-5">Product Type</div>
          <div class="dialog-text pl-3 pt-2">- {{ product.productType }}</div>
          <div class="dialog-title-md mt-5">Delivery Method</div>
          <div class="dialog-text pl-3 pt-2">
            - {{ product.deliveryMethod }}
          </div>
          <div class="dialog-title-md mt-5">Strain / Cultivar</div>
          <div class="dialog-text pl-3 pt-2 fixed-length">
            - {{ product.strainCultivar }}
          </div>
        </v-col>
        <div class="d-block float-right">
          <router-link
            class="text-link-with-icon link-active"
            :to="{ path: '/products/view/' + product._id }"
            >View More</router-link
          >
        </div>
      </div>
    </v-card-text>
  </v-card>

  <v-card
    v-else
    class="list-view card-border"
    :height="$vuetify.breakpoint.mdAndUp ? 'unset' : 'auto'"
  >
    <v-card-text
      class="card-box product-list"
      :class="$vuetify.breakpoint.mdAndUp ? 'd-flex' : ''"
    >
      <v-row>
        <v-col cols="3" class="py-0">
          <router-link
            class="d-flex"
            :to="{ path: '/products/view/' + product._id }"
          >
            <i class="image-box">
              <img
                class="image-box"
                :src="productImage[0].url"
                v-if="productImage.length > 0"
              />
              <img
                class="image-box"
                src="https://growbiotech-prod.s3.amazonaws.com/1606222831391.png"
                v-else
              />
            </i>
            <v-chip
              color="#FDAF19"
              class="white--text video-chip"
              label
              v-if="product.videoUrl"
              >VIDEO</v-chip
            >
          </router-link>
        </v-col>

        <v-col cols="9" class="py-0">
          <v-row>
            <v-col cols="12">
              <div>
                <span class="fixed-length">
                  <router-link
                    class="text-link-with-icon"
                    :to="{ path: '/products/view/' + product._id }"
                  >
                    <span class="dialog-title">
                      <span class="link-active">{{ product.name }}®</span>
                    </span>
                  </router-link>
                </span>
                <span class="dialog-title">
                  <span
                    class="dialog-small-text in-stock-cls font-weight-bold d-inline"
                    v-if="product.stockStatus === 'In Stock'"
                    >In Stock</span
                  >
                  <span
                    class="dialog-small-text in-stock-cls font-weight-bold text--disabled d-inline"
                    v-if="product.stockStatus === 'Out of Stock'"
                    >Out of Stock</span
                  >
                  <span
                    class="dialog-small-text in-stock-cls font-weight-bold d-inline"
                    v-if="product.stockStatus === 'Coming Soon'"
                    >Coming Soon</span
                  >
                  <span
                    class="dialog-small-text in-stock-cls font-weight-bold d-inline"
                    v-if="product.stockStatus === 'Available in 1 week'"
                    >Available in 1 week</span
                  >
                  <span
                    class="dialog-small-text in-stock-cls font-weight-bold d-inline"
                    v-if="product.stockStatus === 'Available in 2 weeks'"
                    >Available in 2 weeks</span
                  >
                  <span
                    class="dialog-small-text in-stock-cls font-weight-bold d-inline"
                    v-if="product.stockStatus === 'Available in 3 weeks'"
                    >Available in 3 weeks</span
                  >
                  <span
                    class="dialog-small-text in-stock-cls font-weight-bold d-inline"
                    v-if="product.stockStatus === 'Available in 4 weeks'"
                    >Available in 4 weeks</span
                  >
                </span>
                <span
                  class="dialog-small-text in-stock-cls font-weight-bold d-inline"
                  v-if="product.stockStatus === 'Low Stock'"
                  >Low Stock</span
                >
              </div>
              <v-card-subtitle class="dialog-text fixed-length pa-0">{{
                product.formulation
              }}</v-card-subtitle>
              <!-- <div class="dialog-title-md mt-5">
                <span v-if="retailPrice.length > 0"
                  >£{{ Math.min(...retailPrice) }}</span
                >
                <span v-if="retailPrice.length > 1"
                  >&nbsp;-&nbsp;£{{ Math.max(...retailPrice) }}</span
                >
              </div> -->
            </v-col>
          </v-row>
          <v-row>
            <v-col :cols="product.qrCodeUrl ? 5 : 6" class="py-0">
              <div class="dialog-title-md mt-1">Product Type</div>
              <div class="dialog-text pl-3 pt-2">
                - {{ product.productType }}
              </div>
              <div class="dialog-title-md mt-5">Delivery Method</div>
              <div class="dialog-text pl-3 pt-2">
                - {{ product.deliveryMethod }}
              </div>
            </v-col>
            <v-col :cols="product.qrCodeUrl ? 5 : 6" class="py-0">
              <div class="dialog-title-md mt-1">Manufacturer</div>
              <div
                v-if="product.manufacturersObj"
                class="dialog-text pl-3 pt-2"
              >
                - {{ product.manufacturersObj.name }}
              </div>

              <div class="dialog-title-md mt-5">Strain / Cultivar</div>
              <div class="dialog-text pl-3 pt-2 fixed-length">
                - {{ product.strainCultivar }}
              </div>
            </v-col>
            <v-col :cols="2" class="pa-0" v-if="product.qrCodeUrl">
              <img :src="product.qrCodeUrl" alt="Qr Code" />
            </v-col>
            <v-col cols="12" class="float-right py-0">
              <router-link
                class="text-link-with-icon float-right link-active"
                :to="{ path: '/products/view/' + product._id }"
                >View More</router-link
              >
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "ListGrid",
  props: {
    selectedList: {
      type: Number,
      required: true,
      default: 0
    },
    product: Object
  },
  computed: {
    productImage() {
      return this.product.media.filter(media => media.mediaType == "image");
    },
    documents() {
      return this.product.media.filter(media => media.mediaType == "doc");
    },
    retailPrice() {
      const priceList = [];
      this.product.retailPrice.filter(priceArr => {
        if (priceArr.price) {
          priceList.push(priceArr.price);
        }
      });
      return priceList;
    }
  }
};
</script>

<style scoped lang="scss">
.card-border {
  border-radius: 4px;
  border: 1px solid #d6e0ef;
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
}
.in-stock-cls {
  color: #30e362;
  text-transform: uppercase;
}
.list-view {
  .img-container-cls {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .fixed-length {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }
  position: relative;
  .document-section {
    position: absolute;
    bottom: 5px;
    right: 5px;
  }
  .card-box {
    border: none;
    height: unset;
    .img-container {
      justify-content: center;
      align-items: center;
    }
    .image-box {
      background: transparent;
      img {
        width: 100%;
        margin: 0 auto;
        height: 270px;
      }
    }
  }
}
.grid-view {
  .fixed-length {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    // height: 30px;
  }
  .card-box {
    border: none;
    height: unset;
    .img-container {
      width: 50%;
      height: 290px;
    }
    .image-box {
      background: transparent;
      img {
        width: 100%;
        height: 290px;
      }
    }
  }
}
.video-chip {
  position: absolute;
  bottom: 16px;
}
.video-chip-grid-view {
  position: absolute;
  left: 20px;
  bottom: 36px;
}
.link-active:hover {
  color: #fcae00 !important;
}
.product-list .image-box {
  min-height: 250px !important;
  img {
    height: 250px !important;
  }
}
</style>
